import React, { useRef, useState } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import {
  validaSoloNumero
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import CatalogoFabricantes from '../../catalogos/catalogoFabricantes';

export const GestionarFabricantes = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'))
  const accbtnmodelo = JSON.parse(sessionStorage.getItem('accbtnmodeloc'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtIdfabricante = useRef();
  const txtDescripcion = useRef();
  const [tituloHeader, setTituloHeader] = useState('Gestionar Fabricantes.')
  const [visibleBtn, setVisibleBtn] = useState('visible')
  const [operacion, setOperacion] = useState(null);
  const [body, setBody] = useState(null);
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [catalogoModelo, setCatalogoModelo] = useState(false);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });

  const onChange = (e) => {

    if (e.target.name === 'descripcion') {
      if (e.target.value === '') {
        setBotones({ ...botones, aceptar: true });
      } else {
        setBotones({ ...botones, aceptar: false });
      }
      e.target.value = e.target.value;
    } else {
      e.target.value = e.target.value;
    }
  }

  const seleccionarRegistro = (id) => {
    let campos = 'idfabricante, trim(descripcion) as descripcion';
    let nomtab = 'fabricante';
    let nomid = 'idfabricante';
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {

        if (response.data !== '') {
          txtIdfabricante.current.setAttribute("disabled", true);
          txtDescripcion.current.value = response.data.descripcion.trim();
          if (operacion === 2) {
            setHabilitado(false);
            txtDescripcion.current.focus();
          } else {
            btnCancela.current.focus();
          }
          setBotones({
            incluir: true,
            consultar: true,
            modificar: false,
            eliminar: true,
            aceptar: operacion === 4 ? true : false,
            cancelar: false,
            catalogo: true,
            salir: true
          });
        } else {
          txtIdfabricante.current.value = '';
          txtIdfabricante.current.focus();
        }
      }
      setActivate(false);
    }).catch(function (error) {
      setActivate(false);
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const validarfabricante = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof (event.which) === 'undefined') {
      if (event.target.value !== '') {

        seleccionarRegistro(event.target.value);

      }
    }
  };

  const onCatalogoFabricante = (values) => {
    setCatalogoModelo(false);
    txtIdfabricante.current.setAttribute("disabled", true);
    txtIdfabricante.current.value = values.idfabricante;
    txtDescripcion.current.value = values.descripcion;
    setBotones({
      incluir: true,
      consultar: true,
      modificar: false,
      eliminar: true,
      aceptar: operacion === 4 ? true : false,
      cancelar: false,
      catalogo: true,
      salir: true
    });
    if (operacion === 2) {
      setHabilitado(false);
      setTimeout(() => txtDescripcion.current.focus(), 200);
      //txtDescripcion.current.focus();
    } else {
      setTimeout(() => btnCancela.current.focus(), 200);
      //btnCancela.current.focus();
    }
  }

  const onChangeValidar = () => {

    let sigue = true;
    if (!botones.incluir || !botones.modificar) {

      if (txtDescripcion.current.value === '') {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe ingresar una descripción', icono: 'informacion' });
        txtDescripcion.current.focus()
        sigue = false
      }
    }

    if (sigue) {

      var fabricante = [];
      fabricante.push({
        idfabricante: txtIdfabricante.current.value === '' ? 0 : txtIdfabricante.current.value,
        descripcion: txtDescripcion.current.value.toUpperCase().trim(),
      })

      setBody({
        fabricante: fabricante
      });


      let msg = '';
      if (operacion === 1) {
        msg = 'Esta Seguro de Registrar estos Datos.';
      } else if (operacion === 2) {
        msg = 'Esta Seguro de Modificar estos Datos.';
      } else if (operacion === 3) {
        msg = 'Esta Seguro de Eliminar estos Datos.';
      }

      setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
    }
  }

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/modelo/actualizarfabricante/${operacion}`;
    axios.post(endpoint, body, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (operacion === 1) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Creado Correctamente', icono: 'exito' });
        } else if (operacion === 2) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Modificado Correctamente', icono: 'exito' });
        } else if (operacion === 3) {
          setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Registro Eliminado Correctamente', icono: 'exito' });
        }
        setActivate(false);
      }
    }).catch(function (error) {
      let mensaje = '';
      if (error.response === undefined) {
        mensaje = 'Error de Conexion'
      } else {
        if (error.response.data.message === 'duplicate key value violates unique constraint "ubicacion_key"') {
          mensaje = 'Ya existe un Registro con este rif'

        }
        else {
          mensaje = error.response.data.message
        }
      }
      setMensaje({ mostrar: true, titulo: 'Error', texto: mensaje, icono: 'error' });
      setActivate(false);
    })
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    if (mensajesino.texto === 'Seguro de Descartar Cambios?' && props.llamado === 2) {
      cancelar()
    } else {
      procesarRegistro();
    }

  };

  const blanquear = () => {
    setActivate(false);
    setTituloHeader('Gestionar Fabricantes.')
    setBody(null);
    setHabilitado(true);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      salir: false
    });
    txtIdfabricante.current.setAttribute("disabled", true);
    txtIdfabricante.current.value = '';
    txtDescripcion.current.value = '';
    setVisibleBtn('visible')
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancela();

  };

  const onBotones = (op) => (e) => {

    e.preventDefault();

    if (op === 1) {

      if (accbtnmodelo && accbtnmodelo.toString().substring(0, 1) === '1') {
        setVisibleBtn('collapse');
        setTituloHeader('Incluir Fabricantes.')
        setOperacion(op);
        setHabilitado(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          salir: true
        });
        txtIdfabricante.current.setAttribute("disabled", true);
        setTimeout(() => txtDescripcion.current.focus(), 200);
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 2) {

      if (accbtnmodelo && accbtnmodelo.toString().substring(1, 2) === '1') {
        setVisibleBtn('collapse');
        setTituloHeader('Editar Fabricantes.')
        setOperacion(op);
        txtIdfabricante.current.removeAttribute("disabled");
        //setHabilitado(false);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          salir: true
        });
        txtIdfabricante.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 3) {

      if (accbtnmodelo && accbtnmodelo.toString().substring(3, 4) === '1') {
        setVisibleBtn('collapse');
        setTituloHeader('Eliminar Fabricantes.')
        setOperacion(op);
        txtIdfabricante.current.removeAttribute("disabled");
        //setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          salir: true
        });
        txtIdfabricante.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 4) {

      if (accbtnmodelo && accbtnmodelo.toString().substring(2, 3) === '1') {
        setVisibleBtn('collapse');
        setTituloHeader('Consultar Fabricantes.')
        setOperacion(op);
        txtIdfabricante.current.removeAttribute("disabled");
        //setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          salir: true
        });
        txtIdfabricante.current.focus();
      } else {
        setMensaje({ mostrar: true, titulo: 'Notificación.', texto: '¡No Posee Permiso para Realizar esta Acción!', icono: 'error' });
      }

    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      if (props.llamado === 2) {

        if (txtDescripcion.current.value === '') {
          blanquear();
          props.onHideCancela();

        } else {

          setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Seguro de Descartar Cambios?', icono: 'confirmacion' });

        }

      } else {
        blanquear();
      }
    } else if (op === 7) {
      setVisibleBtn('visible');
      cancelar();
    }
  }

  const cerrarModal = () => {
    if (props.llamado === 2) {
      props.onHideRenderizar();
      props.onHideCancela();
    }
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const imprimirFabricantes = () => {

    window.open(
      `${op.reportes}/almacen?afiliado=${afiliado}&reporte=ListFabricantes`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );

  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setHabilitado(true);
        if (props.llamado === 2) {
          setOperacion(1);
          setHabilitado(false);
          setBotones({
            incluir: false,
            consultar: true,
            modificar: true,
            eliminar: true,
            aceptar: true,
            cancelar: false,
            catalogo: true,
            salir: true
          });
          txtIdfabricante.current.setAttribute("disabled", true);
          setTimeout(() => txtDescripcion.current.focus(), 200);
          setVisibleBtn('collapse')
        }
      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <Modal.Title style={{ color: "#fff" }}>{tituloHeader} </Modal.Title>

        {/*  <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
          <i className="far fa-window-close"></i>
        </button> */}
        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={onBotones(7)} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>
          <div className='col-md-12 mx-auto px-0'>
            <div className="mb-3 col-pd-140 ml-auto">
              <span >FECHA: <span className='fw-bold fs-6'>{moment(fechasistema).format('DD-MM-YYYY')} </span></span>
            </div>
          </div>
          <div className='border-azul col-md-12 py-3 rounded mx-1' style={{ fontSizeAdjust: '0.6' }}>

            <div className="row col-md-12 rounded mx-auto">

              <div className="input-group input-group-sm mb-3 col-md-6 px-0">
                <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO:</label>
                <input type="text" ref={txtIdfabricante} disabled onKeyUp={validarfabricante} onBlur={validarfabricante} className="form-control fs-6" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                <button disabled={botones.catalogo} type="button" onClick={() => setCatalogoModelo(true)} className="btn btn-success"><i className="fas fa-search"></i></button>
              </div>

              <div className='col-md-1 ml-auto px-0'>
                <div className="input-group input-group-sm">
                  <button className="btn btn-primary btn-sm rounded " onClick={imprimirFabricantes} ><i className="fas fa-print" ></i></button>
                </div>
              </div>

              <div className="input-group input-group-sm col-md-12 px-0">
                <label className="input-group-text" id="inputGroup-sizing-sm">DESCRIPCION:</label>
                <input type="text" ref={txtDescripcion} name='descripcion' autoComplete='off' disabled={habilitado} className="form-control text-uppercase fs-6" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" onChange={onChange} />
              </div>

            </div>


          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className="col-md-12 mx-auto">

          {visibleBtn === 'visible' ?

            <div className='col-md-12 mx-auto row justify-content-between px-0'>
              <button disabled={botones.incluir} onClick={onBotones(1)} className="btn btn-sm mx-1 my-1 col btn-primary rounded-pill" title='Incluir Modelo'><i className="fas fa-plus"> Incluir </i> </button>
              <button disabled={botones.consultar} onClick={onBotones(4)} className="btn btn-sm mx-1 my-1 col btn-info rounded-pill" title='Consultar Modelo' ><i className="fas fa-eye">Consultar</i> </button>
              <button disabled={botones.modificar} onClick={onBotones(2)} className="btn btn-sm mx-1 my-1 col btn-warning rounded-pill" title='Modificar Modelo'><i className="fa fa-edit">Modificar</i> </button>
              <button disabled={botones.eliminar} onClick={onBotones(3)} className="btn btn-sm mx-1 my-1 col btn-danger rounded-pill" title='Eliminar Modelo'><i className="fa fa-trash">Eliminar</i> </button>
            </div>

            :

            <div className='col-md-12 row mx-auto justify-content-end px-0'>
              <button ref={btnAcepta} disabled={botones.aceptar} onClick={onBotones(5)} className="btn col-md-3 mx-1 my-1 btn-sm rounded-pill btn-success "><i className="fas fa-check-circle">  Aceptar</i></button>
              <button ref={btnCancela} disabled={botones.cancelar} onClick={onBotones(6)} className="btn col-md-3 mx-1 my-1 btn-danger btn-sm rounded-pill "><i className="fas fa-window-close"> Cancelar</i></button>
            </div>}

        </div>

      </Modal.Footer>
      <CatalogoFabricantes
        show={catalogoModelo}
        onHideCancelar={() => setCatalogoModelo(false)}
        onHideAceptaCatalogo={onCatalogoFabricante}
      />
    </Modal >
  );
}




// WEBPACK FOOTER //
// ./src/components/almacen/gestionarFabricante.js